import { render, staticRenderFns } from "./pop.vue?vue&type=template&id=450b4516&"
import script from "./pop.vue?vue&type=script&lang=js&"
export * from "./pop.vue?vue&type=script&lang=js&"
import style0 from "./pop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450b4516')) {
      api.createRecord('450b4516', component.options)
    } else {
      api.reload('450b4516', component.options)
    }
    module.hot.accept("./pop.vue?vue&type=template&id=450b4516&", function () {
      api.rerender('450b4516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/pop.vue"
export default component.exports